<template>
  <div class="delyfk-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search" />
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col v-loading="loading" :span="24">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  style="width: 100%"
                  @row-click="openDetails"
                >
                  <el-table-column
                    label="订单号"
                    width="140"
                    fixed
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.order_num }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.product_num }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单类型"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.mark===0">正单</span>
                      <span v-if="scope.row.mark===1">客改单</span>
                      <span v-if="scope.row.mark===2">增补单</span>
                      <span v-if="scope.row.mark===3">色板单</span>
                      <span v-if="scope.row.mark===4">售后单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="品牌"
                    width="130"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.brand_name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="报价时间"
                    width="170"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.offer_time }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="200"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.address }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="状态"
                    width="120"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.status===9" :disable-transitions="true" size="mini" type="warning">待付款</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    fixed="right"
                    align="center"
                    label="操作"
                  >
                    <template slot-scope="scope">
                      <el-button size="mini" icon="el-icon-money" @click.stop="subsist(scope.row)">立即预付</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                />
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="订单预付款"
      :visible.sync="editVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="editForm" v-loading="offerinfoLoading" :model="editForm" :rules="editRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="editForm.ordername" :disabled="true" />
        </el-form-item>
        <el-form-item label="报价详情" prop="offerdetail">
          <el-card shadow="hover" style="font-size: 12px;color:#606266">
            <div>
              <span style="color:#99a9bf">报价员：</span>
              <span>{{ editForm.offername }}</span>
              <span style="color:#99a9bf;margin-left: 20px">报价时间：</span>
              <span>{{ editForm.offertime }}</span>
            </div>
            <div style="">
              <span style="color:#99a9bf">报价单：</span>
              <span><el-button type="text" icon="el-icon-download" title="点击下载报价单" @click="downOffer">{{ editForm.offerfile }}</el-button></span>
            </div>
            <div>
              <span style="color:#99a9bf">总报价：</span>
              <span style="color:#F56C6C;font-size: 16px;font-weight: bold;margin-right: 6px">{{ offerinfo.amount }}</span>元
              <s v-if="offerinfo.amount!==offerinfo.totalprice" style="margin-left: 10px;color:#999;">{{ offerinfo.totalprice }}</s>
              <el-tag v-if="offerinfo.discount>0" type="danger" :disable-transitions="true" size="mini" style="margin-left: 10px">{{ offerinfo.discount }} 折</el-tag>
            </div>
            <div v-if="offerinfo.factorycom>0||offerinfo.designcom>0">
              <span style="color:#99a9bf;">设计承担：</span>
              <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{ offerinfo.designcom }}</span>元
              <span style="color:#99a9bf;margin-left: 20px">工厂承担：</span>
              <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{ offerinfo.factorycom }}</span>元
              <span style="color:#99a9bf;margin-left: 20px">客户承担：</span>
              <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{ offerinfo.clientcom }}</span>元
            </div>
            <div>
              <span style="color:#99a9bf">预付款：</span>
              <span style="color:#F56C6C;font-size: 16px;font-weight: bold;margin-right: 6px">{{ offerinfo.deposit }}</span>元
              <el-tag v-if="offerinfo.isall===0" size="mini" :disable-transitions="true" style="margin-left: 10px">{{ offerinfo.deposit_per }}%</el-tag>
              <el-tag v-if="offerinfo.isall===1" size="mini" :disable-transitions="true" style="margin-left: 10px" type="warning">≤{{ offerinfo.deposit_less }}取全款</el-tag>
            </div>
            <div v-if="offerinfo.reportEndtime!==null&&offerinfo.reportEndtime!==''&&offerinfo.reportEndtime!==undefined">
              <span style="color:#99a9bf;font-size:12px;"><b class="el-icon-info" />
                当前折扣将在 <b v-if="yfkReportTime.day>0">{{ yfkReportTime.day }}天</b> <b>{{ yfkReportTime.hour }} : {{ yfkReportTime.min }} : {{ yfkReportTime.second }}</b>
                <span v-if="offerinfo.reportEndDiscount>0">之后变为 <el-tag type="info" :disable-transitions="true" size="mini">{{ offerinfo.reportEndDiscount }} 折</el-tag></span>
                <span v-if="offerinfo.reportEndDiscount<=0">之后失效</span>
              </span>
            </div>
          </el-card>
        </el-form-item>
        <el-form-item v-if="offerinfo.deposit>0" label="收款账户" prop="aid">
          <el-select v-model="editForm.aid" style="width:100%" placeholder="请选择" clearable filterable>
            <el-option-group
              v-for="gitem in groupList"
              v-if="gitem.nature===0"
              :key="gitem.groupid"
              :label="gitem.account_name"
            >
              <el-option
                v-for="item in accountsList"
                v-if="item.groupid===gitem.groupid"
                :key="item.aid"
                :label="item.name+'（'+item.card+'）'"
                :value="item.aid"
              >
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.card }}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item v-if="offerinfo.deposit>0" label="打款日期" prop="receipttime">
          <el-date-picker
            v-model="editForm.receipttime"
            type="date"
            style="width:240px"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item v-if="offerinfo.deposit>0" label="打款金额" prop="money">
          <el-input v-model="editForm.money" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">元</template></el-input>
        </el-form-item>
        <el-form-item v-if="offerinfo.deposit>0" label="卡号" prop="card">
          <el-input v-model="editForm.card" maxlength="100" placeholder="请输入汇款人“卡号/尾号”，例如“张三/1234”" show-word-limit />
        </el-form-item>
        <el-form-item v-if="offerinfo.deposit>0" label="打款凭证" prop="imgids">
          <MultiImg :key="editForm.key" v-model="editForm.imgids" :limit="9" :size="'sm'" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="editForm.remark" type="textarea" maxlength="300" show-word-limit />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button v-if="offerinfo.deposit<=0" type="primary" icon="el-icon-check" :loading="editloading" @click="subEditTg('editForm')">立即确认</el-button>
          <el-button v-if="offerinfo.deposit>0" type="primary" icon="el-icon-check" :loading="editloading" @click="subEdit('editForm')">立即预付</el-button>
          <el-button type="danger" icon="el-icon-close" :loading="editloading" @click="turn('editForm')">驳回</el-button>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getDealerOrderList } from '@/api/dealer'
import { getErpOrderOfferDetail, getDebitSMSCode, insteadSubsistDown, getReceiptNature, addOrEditCollectApplyConfirm, insteadSubsist } from '@/api/erp'
import { getFileInfo, getGroupReport, getAccounts } from '@/api/pub'
import { getDealerTelList } from '@/api/work'
import MultiImg from '@/components/upload/MultiImg'

export default {
  name: 'Delyfk',
  components: {
    MultiImg
  },
  data() {
    return {
      searchForm: {
        search: ''
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      editloading: false,
      isDisabledCode: true,
      isCodeLoading: false,
      codeBtn: '获取验证码',
      codeTimer: '',
      sounds: 60,
      editForm: {
        key: '',
        orderid: '',
        ordername: '',
        offername: '',
        offertime: '',
        offerfile: '',
        offerfileid: '',
        money: null,
        dedutel: '',
        msg_id: '',
        code: '',
        accid: null,
        deposit: 0,
        accamount: 0,
        card: '',
        imgids: [],
        receipttime: '',
        aid: '',
        remark: ''
      },
      offerinfoLoading: false,
      offerinfo: [],
      editRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        remark: [{ required: false, message: '请在这里填写驳回原因', trigger: 'blur' }],
        money: [{ required: true, message: '请输入打款金额', trigger: 'blur' }],
        dedutel: [{ required: true, message: '请选择扣款验证号码', trigger: 'change' }],
        code: [{ required: true, message: '请输入六位短信验证码', trigger: 'blur' }],
        imgids: [{ required: true, message: '请上传打款凭证', trigger: 'change' }],
        receipttime: [{ required: true, message: '请选择打款日期', trigger: 'change' }],
        aid: [{ required: true, message: '请选择收款账户', trigger: 'change' }],
        card: [{ required: true, message: '请输入卡号', trigger: 'blur' }]
      },
      DealerTelList: [],
      groupList: [],
      applyImgList: [],
      receiptNatureList: [],
      accountsList: [],
      yfkReportTime: {
        curStartTime: '',
        day: 0,
        hour: '00',
        min: '00',
        second: '00'
      }
    }
  },
  computed: {
    user: getUser
  },
  watch: {
    'editForm.dedutel': function(newVal) {
      if (newVal !== null && newVal !== '' && newVal !== undefined) {
        if (this.sounds === 60) {
          this.isDisabledCode = false
        }
      } else {
        this.isDisabledCode = true
      }
    }
  },
  created() {
    this.getData()
    getGroupReport().then(response => {
      this.groupList = response.data
    }).catch(() => {})
    getReceiptNature().then(response => {
      this.receiptNatureList = response.data
    }).catch(() => {})
    getAccounts().then(response => {
      this.accountsList = response.data
    }).catch(() => {})
  },
  methods: {
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        delid: this.user.delid,
        mark: 9
      }
      getDealerOrderList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.$router.push({ path: '/work/delorder/' + row.order_id })
    },
    downOffer() {
      getFileInfo({ fileid: this.editForm.offerfileid }).then(response => {
        /* this.$message({
          message: '报价单已下载',
          type: 'success'
        })*/
        const a = document.createElement('a')
        // a.download = response.data.dName + '.' + response.data.dType
        a.href = response.data.copyPath
        a.target = '_blank'
        a.click()
        const h = this.$createElement
        this.$msgbox({
          title: '下载提示',
          message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
            h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
            h('a',
              { attrs: {
                href: response.data.copyPath,
                target: '_blank',
                download: `${response.data.dName}.${response.data.dType}`,
                style: 'color: #409EFF;text-decoration:underline;'
              }}, `点击这里`),
            h('span', null, `重新下载。`)
          ]),
          showCancelButton: false,
          confirmButtonText: '关闭',
          beforeClose: (action, instance, done) => {
            done()
          }
        }).then(action => {
        })
      }).catch(() => {})
    },
    getCode() {
      if (this.editForm.dedutel !== null && this.editForm.dedutel !== '' && this.editForm.dedutel !== undefined) {
        if (this.editForm.deposit > 0) {
          if (this.editForm.money !== null && parseFloat(this.editForm.money) > 0) {
            if (parseFloat(this.editForm.money) <= parseFloat(this.editForm.accamount)) {
              if (parseFloat(this.editForm.money) >= parseFloat(this.editForm.deposit)) {
                if (!this.isDisabledCode) {
                  if (this.sounds === 60) {
                    this.isCodeLoading = true
                    const arr = this.editForm.dedutel.split('@')
                    const data = {
                      verifyCode: '1434619f6b1b490fc7b225e6c052abd3',
                      opertype: 0,
                      userid: this.user.userid,
                      type: 0,
                      dataid: this.editForm.orderid,
                      amount: this.editForm.money,
                      phoneNum: arr[1],
                      receiver: arr[0]
                    }
                    getDebitSMSCode(data).then(response => {
                      this.editForm.msg_id = response.data
                      this.isCodeLoading = false
                      this.isDisabledCode = true
                      this.codeTimer = setInterval(this.countdown, 1000)
                    }).catch(() => {
                      this.isCodeLoading = false
                    })
                  } else {
                    this.isDisabledCode = true
                  }
                }
              } else {
                this.$message.error('扣款金额至少为 ' + this.editForm.deposit + ' 元')
              }
            } else {
              this.$message.error('账户余额不足')
            }
          } else {
            this.$message.error('请输入扣款金额')
          }
        } else {
          this.$message.error('预付款为0元，无需扣款')
        }
      } else {
        this.$message.error('请选择扣款验证手机号码')
      }
    },
    countdown() {
      this.sounds--
      if (this.sounds === 0) {
        clearInterval(this.codeTimer)
        this.codeBtn = '获取验证码'
        this.isDisabledCode = false
        this.sounds = 60
      } else {
        this.codeBtn = '重新获取 ' + this.sounds
      }
    },
    countReportTime() {
      const date = new Date()
      const now = date.getTime()
      const endDate = new Date(`${this.yfkReportTime.curStartTime} 00:00:00`)
      const end = endDate.getTime()
      const leftTime = end - now
      if (leftTime >= 0) {
        this.yfkReportTime.day = Math.floor(leftTime / 1000 / 60 / 60 / 24)
        const h = Math.floor(leftTime / 1000 / 60 / 60 % 24)
        this.yfkReportTime.hour = h < 10 ? '0' + h : h
        const m = Math.floor(leftTime / 1000 / 60 % 60)
        this.yfkReportTime.min = m < 10 ? '0' + m : m
        const s = Math.floor(leftTime / 1000 % 60)
        this.yfkReportTime.second = s < 10 ? '0' + s : s
      } else {
        this.yfkReportTime.day = 0
        this.yfkReportTime.hour = '00'
        this.yfkReportTime.min = '00'
        this.yfkReportTime.second = '00'
      }
      if (Number(this.yfkReportTime.hour) === 0 && Number(this.yfkReportTime.day) === 0 && Number(this.yfkReportTime.min) === 0 && Number(this.yfkReportTime.second) === 0) {
        return
      } else {
        setTimeout(this.countReportTime, 1000)
      }
    },
    subsist(row) {
      this.editRules.remark[0].required = false
      this.editForm.key = new Date().getTime().toString()
      this.isDisabledCode = true
      this.editForm.orderid = row.order_id
      this.editForm.ordername = row.order_num + ' / ' + row.product_num + ' / ' + row.address
      this.editForm.remark = ''
      this.editForm.offername = row.offername
      this.editForm.offertime = row.offer_time
      this.editForm.offerfile = row.offer_filename
      this.editForm.offerfileid = row.offer_fileid
      this.offerinfo = []
      this.editForm.money = null
      this.editForm.accid = null
      this.editForm.dedutel = ''
      this.editForm.msg_id = ''
      this.editForm.code = ''
      this.editForm.deposit = 0
      this.editForm.accamount = 0
      this.editVisible = true
      this.offerinfoLoading = true
      getDealerTelList({ delid: row.delid, page: 1, limit: 9999999 }).then(response => {
        this.DealerTelList = response.data
      }).catch(() => {})
      getErpOrderOfferDetail({ orderid: row.order_id }).then(response => {
        this.offerinfo = response.data
        if (this.offerinfo.reportEndtime !== null && this.offerinfo.reportEndtime !== '' && this.offerinfo.reportEndtime !== undefined) {
          this.yfkReportTime.curStartTime = this.offerinfo.reportEndtime
          this.countReportTime()
        }
        this.editForm.deposit = this.offerinfo.deposit
        // this.editForm.money = this.editForm.deposit
        this.editForm.accamount = this.offerinfo.accamount
        this.editForm.accid = this.offerinfo.accid
        this.offerinfoLoading = false
      }).catch(() => {
        this.offerinfoLoading = false
      })
    },
    turn(formName) {
      this.editRules.remark[0].required = true
      this.editRules.money[0].required = false
      this.editRules.dedutel[0].required = false
      this.editRules.code[0].required = false
      this.editRules.imgids[0].required = false
      this.editRules.receipttime[0].required = false
      this.editRules.aid[0].required = false
      this.editRules.card[0].required = false
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            this.editloading = true
            const data = {
              userid: this.user.userid,
              orderid: this.editForm.orderid,
              reason: this.editForm.remark,
              type: 0
            }
            insteadSubsistDown(data).then(response => {
              this.$message({
                message: '订单已驳回',
                type: 'success'
              })
              this.editloading = false
              this.editVisible = false
              this.sounds = 60
              if (this.codeTimer !== null && this.codeTimer !== '' && this.codeTimer !== undefined) {
                clearInterval(this.codeTimer)
                this.codeTimer = ''
                this.codeBtn = '获取验证码'
                this.isDisabledCode = true
              }
              this.getData()
            }).catch(() => {
              this.editloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    subEditTg(formName) {
      if (!this.editloading) {
        this.editloading = true
        const data = {
          userid: this.user.userid,
          orderid: this.editForm.orderid,
          pay: 0,
          remark: this.editForm.remark,
          type: 0
        }
        insteadSubsist(data).then(response => {
          this.$message({
            message: '提交成功',
            type: 'success'
          })
          this.editVisible = false
          this.editloading = false
          this.getData()
        }).catch(() => {
          this.editloading = false
        })
      } else {
        return false
      }
    },
    subEdit(formName) {
      this.editRules.remark[0].required = false
      this.editRules.money[0].required = true
      this.editRules.dedutel[0].required = true
      this.editRules.code[0].required = true
      this.editRules.imgids[0].required = true
      this.editRules.receipttime[0].required = true
      this.editRules.aid[0].required = true
      this.editRules.card[0].required = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            if (parseFloat(this.editForm.money) > 0) {
              this.editloading = true
              const data = {
                userid: this.user.userid,
                role: 0,
                applyid: 0,
                dealerid: this.user.delid,
                date: this.editForm.receipttime,
                money: this.editForm.money,
                accountid: this.editForm.aid,
                card: this.editForm.card,
                nature: '预付款',
                imgStr: this.editForm.imgids.join(','),
                remark: this.editForm.remark,
                orderid: this.editForm.orderid
              }
              addOrEditCollectApplyConfirm(data).then(response => {
                this.$message({
                  message: '提交成功',
                  type: 'success'
                })
                this.editVisible = false
                this.editloading = false
                this.editimgList = []
                this.getData()
              }).catch(() => {
                this.editloading = false
              })
            } else {
              this.$message.error('打款金额不可小于0')
              return false
            }
          } else {
            return false
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.delyfk-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
